import { DocumentSearchModel, DocumentViewState } from '@/types';

export function getDocumentSearchModel(state: DocumentViewState) {
  if (state.VersionBeingViewed?.documentId !== undefined) {
    return {
      documentId: state.VersionBeingViewed.documentId,
      cabinetId: state.VersionBeingViewed.cabinet.id,
      documentPagePreferences: state.DocumentModel.documentPagePreferences,
      autoSaveConfiguration: state.DocumentModel.autoSaveConfiguration
    } as DocumentSearchModel;
  }
  if (state.RelatedDocumentBeingViewed?.documentSearchModel !== undefined) {
    return state.RelatedDocumentBeingViewed.documentSearchModel;
  }

  return state.DocumentSearchModel;
}
